import { Editor } from '@tiptap/react';

export const getTextFromSelection = (editor: Editor) => {
  const { from, to } = editor.state.selection;
  return editor.state.doc.textBetween(from, to, ' ');
};
